import styled from 'styled-components';

import UnauthenticatedLayout from '../../../overwrites/views/layouts/UnauthenticatedLayout/UnauthenticatedLayout';
import { ThemeProp } from '../../../theme/Themes';
import { HorizontalContainer, MainButton } from '../auth.styles';

export const SignUpButton = styled(MainButton).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    '&&': {
      ...props.css?.['&&'],
      marginTop: '$5',
      marginBottom: '$8',
    },
  },
}))``;

export const StyledUnauthenticatedLayout = styled(UnauthenticatedLayout).attrs((props) => ({
  ...props,
  pageContainerMaxWidth: '26rem',
}))``;

export const Invite = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.c300};
  margin-bottom: 1.5rem;
`;

export const InviteBlack = styled(Invite)`
  color: ${(props: ThemeProp) => props.theme.colors.neutrals.black};
`;

export const UserNameContainer = styled(HorizontalContainer)`
  align-items: flex-start;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    flex-direction: column;
    gap: 0;
  }
`;
